export default "__VITE_ASSET__D8BASZ9I__"